"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import TaskModalDialog from './TaskModalDialog'
import { useAgreementComplianceModal } from './useAgreementComplianceModal'

interface AgreementComplianceModalProps {
  campaignId: string
  isOpen: boolean
  onClose: () => void
  tasks: AutopilotTaskDto[]
}

const AgreementComplianceModal = ({
  campaignId,
  isOpen,
  onClose,
  tasks,
}: AgreementComplianceModalProps) => {
  const {
    campaign,
    completeDisabled,
    filteredDocuments,
    onSaveCurrentPage,
    renderPage,
  } = useAgreementComplianceModal({ campaignId, isOpen, tasks })

  return (
    <TaskModalDialog
      title={'Agreement Compliance'}
      tasks={tasks}
      open={isOpen}
      onClose={onClose}
      documents={filteredDocuments}
      campaignId={campaignId}
      campaign={campaign!}
      onSaveCurrentPage={onSaveCurrentPage}
      completeDisabled={completeDisabled}
      renderPage={renderPage}
    />
  )
}

export default AgreementComplianceModal
